"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrPush = void 0;
function updateOrPush(array, object, identifier) {
    const index = array.findIndex(item => item[identifier] === object[identifier]);
    if (index === -1) {
        // Object with the specified identifier was not found, so push it to the end of the array
        return [...array, object];
    }
    else {
        // Object with the specified identifier was found, so replace it with the new object
        return [...array.slice(0, index), object, ...array.slice(index + 1)];
    }
}
exports.updateOrPush = updateOrPush;
